import constants from '@/services/constants';
import utilities from '@/services/utilities/utilities';
import getHandInfo from '@/services/simulator/get-info-from-combined-cards/get-hand-info';
import _ from 'lodash';

export default {
  run: function (handInfo, holeCards, communityCards, shortDeck) {
    if (handInfo.name === 'flush') {
      this._setSpecificFlushType(handInfo, holeCards, communityCards, shortDeck);
    }

    else if (handInfo.name === 'three of a kind') {
      this._setSpecificThreeOfAKindType(handInfo, holeCards, communityCards);
    }

    else if (handInfo.name === 'two pair') {
      this._setSpecificTwoPairType(handInfo, holeCards, communityCards);
    }

    else if (handInfo.name === 'pair') {
      this._setSpecificPairType(handInfo, holeCards, communityCards, shortDeck);
    }

    else if (handInfo.name === 'high card') {
      this._setSpecificHighCardType(handInfo, holeCards, communityCards);
    }
  },
  _setSpecificFlushType: function (handInfo, holeCards, communityCards, shortDeck) {
    let numHoleCardsUsed = this.__getNumHoleCardsUsed(handInfo, holeCards, communityCards);
    let nutLevel = this.__getNutLevel(handInfo, holeCards, communityCards, shortDeck);
    let nutLevelCamelCase;

    if (nutLevel === 'nut') {
      nutLevelCamelCase = 'nut';
    } else if (nutLevel === 'second nut') {
      nutLevelCamelCase = 'secondNut';
    } else if (nutLevel === 'third nut') {
      nutLevelCamelCase = 'thirdNut';
    } else if (nutLevel === 'weak') {
      nutLevelCamelCase = 'weak';
    }

    if (numHoleCardsUsed === 0) {
      handInfo.id = 'usingABoardCard:flushOnBoard';
      handInfo.type = 'on board';
    } else if (numHoleCardsUsed === 1) {
      handInfo.id = 'usingABoardCard:flushUsingOneHoleCard:' + nutLevelCamelCase;
      handInfo.type = 'using one hole card - ' + nutLevel;
    } else if (numHoleCardsUsed === 2) {
      handInfo.id = 'flush:' + nutLevelCamelCase;
      handInfo.type = 'using two hole cards - ' + nutLevel;
    } else {
      throw new Error('Invalid value for numHoleCardsUsed.');
    }
  },
  __getNumHoleCardsUsed: function (handInfo, holeCards, communityCards) {
    let flushSuit = handInfo.suit;
    let numHandCardsThatAreHoleCards = 0;
    let numCommunityCardsOfFlushSuit = this.___getNumMatches(communityCards, function (communityCard) {
      let communityCardSuit = communityCard[1];
      return communityCardSuit === flushSuit;
    });
    let numHoleCardsOfFlushSuit = this.___getNumMatches(holeCards, function (holeCard) {
      let holeCardSuit = holeCard[1];
      return holeCardSuit === flushSuit;
    });

    if (numCommunityCardsOfFlushSuit === 3 && numHoleCardsOfFlushSuit === 2) {
      return 2;
    } else if (numCommunityCardsOfFlushSuit === 4 && numHoleCardsOfFlushSuit >= 1) {
      return 1;
    } else if (numCommunityCardsOfFlushSuit === 5) {
      numHandCardsThatAreHoleCards = this.___getNumMatches(holeCards, function (holeCard) {
        return handInfo.handCards.includes(holeCard);
      });

      if (numHandCardsThatAreHoleCards >= 1) {
        return 1;
      } else if (numHandCardsThatAreHoleCards === 0) {
        return 0;
      }
    }
  },
  ___getNumMatches: function (arr, arg2) {
    let count = 0;

    // predicate function was passed in to test for matching
    if (typeof arg2 === 'function') {
      arr.forEach(function (el) {
        if (arg2(el)) {
          count++;
        }
      });
    }

    // value was passed in to test for matching
    else {
      arr.forEach(function (el) {
        if (el === arg2) {
          count++;
        }
      });
    }

    return count;
  },
  __getNutLevel: function (handInfo, holeCards, communityCards, shortDeck) {
    let communityCardFlushRanks;
    let unusedRanks;
    let holeCardsOfFlushSuit;
    let biggestHoleCardOfFlushSuitRank;
    let nutLevelIndex;
    let flushSuit;

    flushSuit = handInfo.suit;
    communityCardFlushRanks = [];
    communityCards.forEach(function (communityCard) {
      let communityCardRank = communityCard[0];
      let communityCardSuit = communityCard[1];

      if (communityCardSuit === flushSuit) {
        communityCardFlushRanks.push(communityCardRank);
      }
    });
    unusedRanks = constants.ranks.filter(function (rank) {
      let isACommunityCardFlushRank;
      let makesARoyalOrStraightFlush;

      isACommunityCardFlushRank = communityCardFlushRanks.includes(rank);
      if (isACommunityCardFlushRank) {
        return false;
      }

      if (shortDeck) {
        makesARoyalOrStraightFlush = !!getHandInfo._checkForFiveOrMoreRanksInARowShortDeck(
          _.union(communityCardFlushRanks, [rank]).sort(utilities.ranks.sortRanksDescendingCompareFunction)
        );
      } else {
        makesARoyalOrStraightFlush = !!getHandInfo._checkForFiveOrMoreRanksInARow(
          _.union(communityCardFlushRanks, [rank]).sort(utilities.ranks.sortRanksDescendingCompareFunction)
        );
      }
      if (makesARoyalOrStraightFlush) {
        return false;
      }

      return true;
    });
    holeCardsOfFlushSuit = holeCards.filter(function (holeCard) {
      let holeCardSuit = holeCard[1];
      return holeCardSuit === flushSuit;
    });
    biggestHoleCardOfFlushSuitRank = utilities.ranks.getHighestRankFromCards(holeCardsOfFlushSuit);
    nutLevelIndex = unusedRanks.indexOf(biggestHoleCardOfFlushSuitRank);

    if (holeCardsOfFlushSuit.length > 0 && nutLevelIndex === -1) {
      throw new Error('Error getting nut level');
    } else if (nutLevelIndex === 0) {
      return 'nut';
    } else if (nutLevelIndex === 1) {
      return 'second nut';
    } else if (nutLevelIndex === 2) {
      return 'third nut';
    } else if (nutLevelIndex >= 3 && nutLevelIndex <= 12) {
      return 'weak';
    } else if (nutLevelIndex !== -1) {
      throw new Error('Invalid value of nutLevelIndex.');
    }
  },
  _setSpecificThreeOfAKindType: function (handInfo, holeCards, communityCards) {
    let threeOfAKindCards = handInfo.handCards.slice(0,3);
    let threeOfAKindRank = handInfo.rank;
    let numHoleCardsUsedInThreeOfAKind = this.___getNumMatches(holeCards, function (holeCard) {
      return threeOfAKindCards.includes(holeCard);
    });

    if (numHoleCardsUsedInThreeOfAKind === 0) {
      handInfo.id = 'usingABoardCard:threeOfAKindOnBoard';
      handInfo.type = 'on board';
    } else if (numHoleCardsUsedInThreeOfAKind === 1) {
      handInfo.id = 'threeOfAKind:trips';
      handInfo.type = 'trips';
    } else if (numHoleCardsUsedInThreeOfAKind === 2) {
      communityCards.sort(utilities.ranks.sortCardsDescendingByRankCompareFunction);

      if (communityCards.length === 3) {
        if (communityCards[0][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:topSet';
          handInfo.type = 'top set';
        } else if (communityCards[1][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:middleSet';
          handInfo.type = 'middle set';
        } else if (communityCards[2][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:bottomSet';
          handInfo.type = 'bottom set';
        }
      }

      else if (communityCards.length === 4) {
        if (communityCards[0][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:topSet';
          handInfo.type = 'top set';
        } else if (communityCards[1][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:secondSet';
          handInfo.type = 'second set';
        } else if (communityCards[2][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:thirdSet';
          handInfo.type = 'third set';
        } else if (communityCards[3][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:bottomSet';
          handInfo.type = 'bottom set';
        }
      }

      else if (communityCards.length === 5) {
        if (communityCards[0][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:topSet';
          handInfo.type = 'top set';
        } else if (communityCards[1][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:secondSet';
          handInfo.type = 'second set';
        } else if (communityCards[2][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:thirdSet';
          handInfo.type = 'third set';
        } else if (communityCards[3][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:fourthSet';
          handInfo.type = 'fourth set';
        } else if (communityCards[4][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:bottomSet';
          handInfo.type = 'bottom set';
        }
      }
    } else {
      throw new Error('Invalid value for numHoleCardsUsedInThreeOfAKind.');
    }
  },
  _setSpecificTwoPairType: function (handInfo, holeCards, communityCards) {
    let holeCardRanks = [ holeCards[0][0], holeCards[1][0] ];
    holeCardRanks.sort(utilities.ranks.sortRanksDescendingCompareFunction);
    let largerHoleCardRank = holeCardRanks[0];
    let smallerHoleCardRank = holeCardRanks[1];
    let holeCardsArePaired = largerHoleCardRank === smallerHoleCardRank;
    let twoPairRanks = [ handInfo.higherPairRank, handInfo.lowerPairRank ];
    let largestCommunityCardRank = communityCards.sort(utilities.ranks.sortCardsDescendingByRankCompareFunction)[0][0];
    let bothHoleCardsUsedForTwoPair;
    let oneHoleCardUsedForTwoPair;

    if (holeCardsArePaired) {
      if (twoPairRanks.includes(largerHoleCardRank)) {
        handInfo.id = 'usingABoardCard:twoPairWithPairOnBoard';
        handInfo.type = 'pair on board';
      } else {
        handInfo.id = 'usingABoardCard:twoPairOnBoard';
        handInfo.type = 'on board';
      }
    }

    else if (!holeCardsArePaired) {
      bothHoleCardsUsedForTwoPair = twoPairRanks.includes(largerHoleCardRank) && twoPairRanks.includes(smallerHoleCardRank);
      oneHoleCardUsedForTwoPair = twoPairRanks.includes(largerHoleCardRank) !== twoPairRanks.includes(smallerHoleCardRank); // xor

      if (bothHoleCardsUsedForTwoPair) {
        if (twoPairRanks.includes(largestCommunityCardRank)) {
          handInfo.id = 'twoPair:usingTopBoardCard';
          handInfo.type = 'using top board card';
        } else {
          handInfo.id = 'twoPair:weak';
          handInfo.type = 'weak';
        }
      } else if (oneHoleCardUsedForTwoPair) {
        handInfo.id = 'usingABoardCard:twoPairWithPairOnBoard';
        handInfo.type = 'pair on board';
      } else { // no hole cards used for two pair
        handInfo.id = 'usingABoardCard:twoPairOnBoard';
        handInfo.type = 'on board';
      }
    }
  },
  _setSpecificPairType: function (handInfo, holeCards, communityCards, shortDeck) {
    let communityCardRanks;
    let pairRankPosition;
    let kickerType;
    let kickerRank;

    communityCardRanks = [];
    communityCards.forEach(function (communityCard) {
      communityCardRanks.push(communityCard[0]);
    });

    // when there is a pair on the board
    if (utilities.general.checkForDuplicates(communityCardRanks)) {
      handInfo.id = 'usingABoardCard:pairOnBoard';
      handInfo.type = 'on board';
      return;
    }

    communityCardRanks.sort(utilities.ranks.sortRanksDescendingCompareFunction);
    pairRankPosition = utilities.ranks.getRankPositionAmongstCommunityCards(handInfo.rank, communityCardRanks);

    if (pairRankPosition === 'over') {
      handInfo.id = 'pair:overpair';
      handInfo.type = 'overpair';
    } else if (pairRankPosition === 'top') {
      holeCards.forEach(function (holeCard) {
        if (holeCard[0] !== handInfo.rank) {
          kickerRank = holeCard[0];
        }
      });
      kickerType = this.__getKickerType(kickerRank, communityCardRanks, shortDeck);
      handInfo.type = 'top pair, ' + kickerType + ' kicker';

      if (kickerType === 'top') {
        handInfo.id = 'pair:tptk';
      } else if (kickerType === 'good') {
        handInfo.id = 'pair:tpgk';
      } else if (kickerType === 'weak') {
        handInfo.id = 'pair:tpwk';
      }
    } else if (pairRankPosition === 'over middle' || pairRankPosition === 'over second') {
      handInfo.id = 'pair:ppUnderTp';
      handInfo.type = 'pocket pair under top pair';
    } else if (pairRankPosition === 'second') {
      handInfo.id = 'pair:secondPair';
      handInfo.type = 'second';
    } else if (pairRankPosition === 'middle') {
      handInfo.id = 'pair:middlePair';
      handInfo.type = 'middle';
    } else {
      handInfo.id = 'pair:weakPair';
      handInfo.type = 'weak';
    }
  },
  __getKickerType: function (kickerRank, communityCardRanks, shortDeck) {
    // a8 on akqj9
    // 8765432
    let unusedRanks = constants.ranks.filter(function (rank) {
      let isACommunityCardRank;
      let makesAStraight;

      isACommunityCardRank = communityCardRanks.includes(rank);
      if (isACommunityCardRank) {
        return false;
      }

      if (shortDeck) {
        makesAStraight = !!getHandInfo._checkForFiveOrMoreRanksInARowShortDeck(
          _.union(communityCardRanks, [rank]).sort(utilities.ranks.sortRanksDescendingCompareFunction)
        );
      } else {
        makesAStraight = !!getHandInfo._checkForFiveOrMoreRanksInARow(
          _.union(communityCardRanks, [rank]).sort(utilities.ranks.sortRanksDescendingCompareFunction)
        );
      }
      if (makesAStraight) {
        return false;
      }

      return true;
    });
    let kickerRankIndexInUnusedRanks = unusedRanks.indexOf(kickerRank);

    if (kickerRankIndexInUnusedRanks === 0) {
      return 'top';
    } else if (kickerRankIndexInUnusedRanks === 1 || kickerRankIndexInUnusedRanks === 2) {
      return 'good';
    } else if (kickerRankIndexInUnusedRanks > 2) {
      return 'weak';
    } else {
      throw new Error('Error getting kicker type.');
    }
  },
  _setSpecificHighCardType: function (handInfo, holeCards, communityCards) {
    let highCardRank = handInfo.kickers[0][0];
    let highHoleCardRank = holeCards.sort(utilities.ranks.sortCardsDescendingByRankCompareFunction)[0][0];

    if (highHoleCardRank === 'a') {
      handInfo.id = 'highCard:aceHigh';
      handInfo.type = 'ace high';
    } else if (highHoleCardRank === 'k' && highCardRank !== 'a') {
      handInfo.id = 'highCard:kingHigh';
      handInfo.type = 'king high';
    } else {
      handInfo.id = 'highCard:weak';
      handInfo.type = 'weak';
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/simulator/get-info-from-combined-cards/set-specific-hand-info.js